
$(document).ready(function () {

  // General Message
  $('.generalmessage').prependTo('header');

  // Mobile dropdown layout
  $('.mobile-menu-subheader, .search-container, .mobile-menu-ticket-btn, .mobile-menu-slider, .mobile-menu-footer-links').wrapAll(`<div class="dropdown-wrap-containers"></div>`)

  // Menu button
  $('.mobile-nav-toggle').append(`
  <div></div>
  <div></div>
  <div></div>
  `)

  // Glow for header
  $('.headerInnerContent').append('<div class="overlay-logo"></div>');


  // NavBar animation
  $('.groups .group').each(function () {
    let nmbrSlides = 1;
    $(this).find('.items > .item').each(function () {
      let nmbrSubSlides = 1;
      $(this).addClass(`dropdown_menu-${nmbrSlides}`);
      nmbrSlides++;

      $(this).find(".subitems > .item").each(function () {
        $(this).addClass(`dropdown_submenu-${nmbrSubSlides}`);
        nmbrSubSlides++;
      });
    });
  });
})
